import React, { useEffect } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import styles from "../../../assets/jss/components/tableStyle";
import {
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Button,
  TextField,
  Icon,
  FormControl,
  Grid,
  MenuItem,
  Select,
  InputLabel,
  FormHelperText,
  IconButton,
  Collapse,
  Grow,
  Slide,
  Tooltip,
  Badge,
} from "@material-ui/core";
import CardBody from "../../../common/components/Card/CardBody";
import { DropzoneArea } from "material-ui-dropzone";
import Card from "../../../common/components/Card/Card";
import CardHeader from "../../../common/components/Card/CardHeader";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { EducationalActivityRepository } from "./EducationalActivityRepository";
import {
  educationalActivityValidator,
  educationalActivityPointsValidator,
} from "./EducationalActivityValidator";
import Upload from "../../../common/components/Upload";
import { LOCALE } from "../../../properties/Locale";
import GradingCommentComponent from "./GradingCommentComponent";
import { Alert, AlertTitle } from "@material-ui/lab";

const useStyles = makeStyles(styles);

export default function EducationalActivityComponent(props) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [educationalActivityTypes, setEducationalActivityTypes] =
    React.useState();
  const [educationalActivityRoles, setEducationalActivityRoles] =
    React.useState();
  const [btnDisabled, setBtnDisabled] = React.useState(false);
  const [rerender, triggerRerender] = React.useState(false);
  const [educationalActivityData, setEducationalActivityData] = React.useState(
    []
  );
  const [
    educationalActivityDataFormErrors,
    setEducationalActivityDataFormErrors,
  ] = React.useState({});
  const [showCommentDialog, setShowCommentDialog] = React.useState(false);
  const [commentItem, setCommentItem] = React.useState();
  const [commentIndex, setCommentIndex] = React.useState();

  useEffect(() => {
    triggerRerender(!rerender);
  }, [educationalActivityDataFormErrors]);

  useEffect(() => {
    EducationalActivityRepository.getAllRoles(props.gradingSchemaId).then(
      (res) => {
        setEducationalActivityRoles(res.data);
      }
    );
    EducationalActivityRepository.getAllTypes(props.gradingSchemaId).then(
      (res) => {
        setEducationalActivityTypes(res.data);
      }
    );
    EducationalActivityRepository.getEducationalActivityData(
      props.vacancyAppId
    ).then(
      (res) => {
        if (res.data.length > 0) setEducationalActivityData(res.data);
      },
      (err) => {}
    );
  }, []);

  const addRow = () => {
    let data = educationalActivityData;
    data.push({
      name: "",
      type: { id: "" },
      role: { id: "" },
      duration: "",
      year: "",
      proofs: [],
    });
    setEducationalActivityData(data);
    setEducationalActivityDataFormErrors({});
    triggerRerender(!rerender);
  };

  const deleteRow = (index) => {
    let data = educationalActivityData;
    data.splice(index, 1);
    setEducationalActivityData(data);
    setEducationalActivityDataFormErrors({});
    triggerRerender(!rerender);
  };

  const handleChange = (event, index, name) => {
    let data = educationalActivityData;
    if (name == "role" || name == "type") {
      data[index][name]["id"] = event.target.value;
    } else {
      data[index][name] = event.target.value;
    }
    setEducationalActivityData(data);
    setEducationalActivityDataFormErrors({});
    triggerRerender(!rerender);
  };

  const handleChangeDate = (date, index, name) => {
    let data = educationalActivityData;
    data[index][name] = date;
    setEducationalActivityData(data);
    triggerRerender(!rerender);
  };

  const handleClickNext = () => {
    setBtnDisabled(true);
    let data = educationalActivityData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!educationalActivityValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("next");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await educationalActivityValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setEducationalActivityDataFormErrors(validationErrors);
    }
  };

  const handleClickPrev = () => {
    setBtnDisabled(true);
    let data = educationalActivityData;
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!educationalActivityValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      saveData("prev");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await educationalActivityValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setEducationalActivityDataFormErrors(validationErrors);
    }
  };

  const saveData = (step) => {
    EducationalActivityRepository.saveEducationalActivityData(
      props.vacancyAppId,
      educationalActivityData
    ).then(
      (res) => {
        if (step === "next") {
          props.handleNextStep();
        } else {
          props.handlePreviousStep();
        }
      },
      (err) => {
        setBtnDisabled(false);
      }
    );
  };

  const addAttachments = (index, attachments) => {
    let data = educationalActivityData;
    data[index].proofs = attachments;
    setEducationalActivityData(data);
  };

  const changePoints = (item) => {
    EducationalActivityRepository.updatePoints(item.id, item.points).then(
      (res) => {
        EducationalActivityRepository.getEducationalActivityData(
          props.vacancyAppId
        ).then(
          (res) => {
            if (res.data.length > 0) {
              setEducationalActivityData(res.data);
              setEducationalActivityDataFormErrors({});
              triggerRerender(!rerender);
            }
          },
          (err) => {}
        );
      }
    );
  };

  const unlockPoints = (item) => {
    EducationalActivityRepository.unlockPoints(item.id).then((res) => {
      EducationalActivityRepository.getEducationalActivityData(
        props.vacancyAppId
      ).then(
        (res) => {
          if (res.data.length > 0) {
            setEducationalActivityData(res.data);
            triggerRerender(!rerender);
          }
        },
        (err) => {}
      );
    });
  };

  const evaluationNextStep = (data) => {
    var validFormData = true;
    for (var i = 0; i < data.length; i++) {
      if (!educationalActivityPointsValidator.isValidSync(data[i])) {
        validFormData = false;
        break;
      }
    }
    if (validFormData) {
      props.handleEvaluationNextStep(data, "educational_activity");
    } else {
      var validationErrors = [];
      (async () => {
        for (var i = 0; i < data.length; i++) {
          validationErrors[i] = {};
          await educationalActivityPointsValidator
            .validate(data[i], { abortEarly: false })
            .catch((err) => {
              err.inner.forEach((validationError) => {
                console.log("Validation error:", validationError);
                validationErrors[i][validationError.path] = {};
                validationErrors[i][validationError.path].message =
                  validationError.message;
              });
            });
        }
      })();
      setBtnDisabled(false);
      setEducationalActivityDataFormErrors(validationErrors);
    }
  };

  const openCommentDialog = (item, index) => {
    setCommentItem(item);
    setCommentIndex(index);
    setShowCommentDialog(true);
  };

  const closeCommentDialog = (item, index) => {
    if (item != undefined) {
      EducationalActivityRepository.setComment(item.id, item.comment).then(
        (res) => {
          let tmp = educationalActivityData;
          tmp[index] = item;
          setEducationalActivityData(tmp);
          triggerRerender(!rerender);
          setShowCommentDialog(false);
        }
      );
    } else {
      setShowCommentDialog(false);
    }
  };

  return (
    <div>
      {!props.disabled && (
        <Alert
          style={{ marginBottom: "45px", marginTop: "10px" }}
          fullwidth="true"
          severity="info"
        >
          <AlertTitle>{LOCALE.educational_acvitity_info_title}</AlertTitle>
          {LOCALE.educational_acvitity_info_description}
        </Alert>
      )}
      <Card>
        <CardHeader
          color="theme"
          style={{ padding: "8px", paddingLeft: "15px" }}
        >
          <Grid container>
            <Grid item xs={8}>
              {" "}
              <Typography>
                {LOCALE.list_of_proofs_for_professional_development},{" "}
                {LOCALE.domain} {LOCALE.educational_activities}
              </Typography>
            </Grid>
            <Grid item xs={2}></Grid>
            <Grid item xs={2}>
              {" "}
              {!props.disabled && (
                <div>
                  <Button
                    color="default"
                    variant="contained"
                    className={
                      educationalActivityData.length == 0 ? "bounceButton" : ""
                    }
                    startIcon={<Icon>add_circle_outline</Icon>}
                    size="small"
                    aria-label="create"
                    style={{ float: "right" }}
                    onClick={addRow}
                  >
                    {LOCALE.add_activity}
                  </Button>
                </div>
              )}
            </Grid>
          </Grid>
        </CardHeader>
        <CardBody>
          <Table aria-label="groups table" className={classes.table}>
            <TableHead>
              <TableRow className={classes.tableHeadRow}>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.num}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.educational_activity_name}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.educational_activity_type}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.educational_activity_role}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.educational_activity_duration}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.educational_activity_year}
                </TableCell>

                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.proof}
                </TableCell>
                <TableCell
                  className={classes.tableCell + " " + classes.tableHeadCell}
                >
                  {LOCALE.actions}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {educationalActivityData.length > 0 ? (
                educationalActivityData.map((item, index) => (
                  <TableRow
                    key={index}
                    className={classes.tableBodyRow}
                    style={index % 2 ? { background: "#f0f0f0" } : {}}
                  >
                    <TableCell className={classes.tableCell}>
                      {index + 1}
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.name}
                          variant="outlined"
                          label={LOCALE.educational_activity_name}
                          error={educationalActivityDataFormErrors[index]?.name}
                          helperText={
                            educationalActivityDataFormErrors[index]?.name
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "name")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.type.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          variant="outlined"
                          error={
                            educationalActivityDataFormErrors[index] &&
                            educationalActivityDataFormErrors[index]["type.id"]
                          }
                          size="small"
                          style={{ width: "250px" }}
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.educational_activity_type}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.educational_activity_type}
                            value={item.type.id}
                            onChange={(e) => handleChange(e, index, "type")}
                          >
                            {educationalActivityTypes?.map((item, index) => (
                              <MenuItem value={item.id} key={index}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {educationalActivityDataFormErrors[index] &&
                              educationalActivityDataFormErrors[index][
                                "type.id"
                              ]?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.role.name}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <FormControl
                          disabled={props.disabled}
                          className={classes.formControl}
                          variant="outlined"
                          error={
                            educationalActivityDataFormErrors[index] &&
                            educationalActivityDataFormErrors[index]["role.id"]
                          }
                          size="small"
                          style={{ width: "250px" }}
                        >
                          <InputLabel id="demo-simple-select-label">
                            {LOCALE.educational_activity_role}
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            label={LOCALE.educational_activity_role}
                            value={item.role.id}
                            onChange={(e) => handleChange(e, index, "role")}
                          >
                            {educationalActivityRoles?.map((item, index) => (
                              <MenuItem value={item.id} key={index}>
                                {item.name}
                              </MenuItem>
                            ))}
                          </Select>
                          <FormHelperText id="municipality-helper-text">
                            {educationalActivityDataFormErrors[index] &&
                              educationalActivityDataFormErrors[index][
                                "role.id"
                              ]?.message}
                          </FormHelperText>
                        </FormControl>
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.duration}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.duration}
                          variant="outlined"
                          label={LOCALE.educational_activity_duration}
                          error={
                            educationalActivityDataFormErrors[index]?.duration
                          }
                          helperText={
                            educationalActivityDataFormErrors[index]?.duration
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "duration")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <Tooltip
                        title={item.year}
                        style={{ color: "white" }}
                        disableHoverListener={!props.evaluation}
                      >
                        <TextField
                          disabled={props.disabled}
                          value={item.year}
                          variant="outlined"
                          label={LOCALE.educational_activity_year}
                          error={educationalActivityDataFormErrors[index]?.year}
                          helperText={
                            educationalActivityDataFormErrors[index]?.year
                              ?.message
                          }
                          size="small"
                          onChange={(e) => handleChange(e, index, "year")}
                        />
                      </Tooltip>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                      <FormControl
                        className={classes.formControl}
                        variant="outlined"
                        error={
                          educationalActivityDataFormErrors[index] &&
                          educationalActivityDataFormErrors[index]["proofs"]
                        }
                        size="small"
                      >
                        <Upload
                          vacancyAppDomain={"EDUCATIONAL_ACTIVITY"}
                          vacancyAppId={props.vacancyAppId}
                          attachments={item.proofs}
                          onComponentClose={addAttachments}
                          rowIndex={index}
                          disabled={props.disabled}
                        />
                        <FormHelperText id="municipality-helper-text">
                          {educationalActivityDataFormErrors[index] &&
                            educationalActivityDataFormErrors[index]["proofs"]
                              ?.message}
                        </FormHelperText>{" "}
                      </FormControl>
                    </TableCell>
                    {props.showPoints && (
                      <React.Fragment>
                        <TableCell className={classes.tableCell}>
                          <TextField
                            disabled={true}
                            value={item.points}
                            variant="outlined"
                            label={LOCALE.points}
                            style={{ maxWidth: "80px" }}
                            size="small"
                          />
                        </TableCell>
                      </React.Fragment>
                    )}
                    {!props.disabled && (
                      <TableCell className={classes.tableCell}>
                        <IconButton
                          disabled={props.disabled}
                          color="secondary"
                          size="small"
                          aria-label="delete"
                          onClick={() => deleteRow(index)}
                        >
                          <Icon>delete</Icon>
                        </IconButton>
                        {/* {props.status === "ADDITIONAL_DATA_REQUIRED" && (
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "6px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                        )} */}
                      </TableCell>
                    )}
                    {props.evaluation && (
                      <TableCell className={classes.tableCell} width={150}>
                        <FormControl
                          style={{ display: "inline" }}
                          error={
                            educationalActivityDataFormErrors[index] &&
                            educationalActivityDataFormErrors[index][
                              "pointsChecked"
                            ]
                          }
                        >
                          <TextField
                            disabled={item.pointsChecked}
                            value={item.points}
                            variant="outlined"
                            label="Поени"
                            style={{ maxWidth: "80px" }}
                            size="small"
                            onChange={(e) => handleChange(e, index, "points")}
                          />
                          {!item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.confirm_points}
                              aria-label={LOCALE.confirm_points}
                            >
                              <IconButton
                                style={{ color: "green", top: "6px" }}
                                size="small"
                                onClick={() => changePoints(item)}
                              >
                                <Icon>check</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          {item.pointsChecked && (
                            <Tooltip
                              title={LOCALE.change_points}
                              aria-label={LOCALE.change_points}
                            >
                              <IconButton
                                style={{ color: "red", top: "6px" }}
                                size="small"
                                onClick={() => unlockPoints(item)}
                              >
                                <Icon>clear</Icon>
                              </IconButton>
                            </Tooltip>
                          )}
                          <Tooltip
                            title={LOCALE.comment}
                            aria-label={LOCALE.comment}
                          >
                            <Badge
                              badgeContent={item.comment ? 1 : 0}
                              color="secondary"
                            >
                              <IconButton
                                color="primary"
                                size="small"
                                style={{ top: "6px" }}
                                onClick={() => openCommentDialog(item, index)}
                              >
                                <Icon>message</Icon>
                              </IconButton>
                            </Badge>
                          </Tooltip>
                          <FormHelperText id="municipality-helper-text">
                            {educationalActivityDataFormErrors[index] &&
                              educationalActivityDataFormErrors[index][
                                "pointsChecked"
                              ]?.message}
                          </FormHelperText>{" "}
                        </FormControl>
                      </TableCell>
                    )}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8}>
                    <Icon style={{ verticalAlign: "bottom", color: "orange" }}>
                      warning
                    </Icon>{" "}
                    {LOCALE.no_activities_added}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </CardBody>
      </Card>
      {!props.disabled && (
        <div>
          <Button
            color="secondary"
            variant="contained"
            disabled={btnDisabled}
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            onClick={() => handleClickNext()}
          >
            {LOCALE.next}
          </Button>
          <Button
            style={{ marginRight: "5px", float: "right" }}
            color="secondary"
            variant="outlined"
            disabled={btnDisabled}
            size="small"
            onClick={() => handleClickPrev()}
          >
            {LOCALE.previous}
          </Button>
        </div>
      )}
      {props.evaluation && (
        <div>
          <Button
            color="primary"
            variant="contained"
            style={{ marginRight: "5px", float: "right" }}
            size="small"
            disabled={btnDisabled}
            onClick={() => evaluationNextStep(educationalActivityData)}
          >
            {LOCALE.next}
          </Button>
        </div>
      )}
      {showCommentDialog && (
        <GradingCommentComponent
          item={commentItem}
          preview={props.status === "ADDITIONAL_DATA_REQUIRED" ? true : false}
          index={commentIndex}
          handleClose={(item, index) => closeCommentDialog(item, index)}
        />
      )}
    </div>
  );
}
